// src/pages/Orders.jsx
import React, { useEffect, useState } from "react";
import { API_BASE_URL } from "../config";
import "../styles/Orders.css";

const Orders = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/orders/`);
        const data = await res.json();
        setOrders(data);
      } catch (err) {
        console.error("Error al obtener órdenes:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchOrders();
  }, []);

  if (loading) return <div className="loading">Cargando órdenes...</div>;

  return (
    <div className="orders-container">
      <h2 className="orders-title">Mis Órdenes</h2>
      {orders.length === 0 ? (
        <p className="no-orders">No tienes órdenes registradas.</p>
      ) : (
        <ul className="orders-list">
          {orders.map((order) => (
            <li key={order.id} className="order-card">
              <p><strong>Cliente:</strong> {order.customer_name}</p>
              <p><strong>Dirección:</strong> {order.address}</p>
              <p><strong>Teléfono:</strong> {order.phone}</p>
              <p><strong>Método de pago:</strong> {order.payment_method}</p>
              <p><strong>Estado:</strong> {order.status}</p>
              <p><strong>Total:</strong> ${order.total.toFixed(2)}</p>
              <p><strong>Fecha:</strong> {new Date(order.created_at).toLocaleString()}</p>
              {order.items && (
                <ul className="order-items">
                  {order.items.map((item, idx) => (
                    <li key={idx}>
                      {item.product_name} x{item.quantity} - ${item.price}
                    </li>
                  ))}
                </ul>
              )}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default Orders;
